import { IMessageTemplate } from '../types/Message.types';

export const InfluitiveBlankMessage: IMessageTemplate = {
  name: 'Blank Template',
  message: '',
  templateId: 999,
  subject: '',
  deletedAt: undefined,
};
